export const environment = {
    "production": true,
    "baseUrl": "",
    "useHash": false,
    "hmr": false,
    "sentry_dsn": "https://dcc9591cf9aa8de43914f057be4e6c48@sentry.hoefges.net/4",
    "sentry_project": "web-admin",
    "sentry_trace_rate": 0,
    "sentry_release": "production",
    "sentry_environment": "production",
    "apiDomain": ""
};
